import type { RegionSalesRow, SalesRegion, SalesTotals } from '../../../../api/daily-sales';
import { addTotals, formatCount, formatMoney, ZERO } from '../daily-sales-format';

interface DailySalesRegionsProps {
  rows: RegionSalesRow[];
  region: SalesRegion | null;
  onRegion: (regionId: string) => void;
}

function combined(row: RegionSalesRow): SalesTotals {
  return addTotals(row.fareharbor ?? ZERO, row.nebari);
}

function cells(t: SalesTotals): string[] {
  return [formatCount(t.bookings), formatCount(t.tickets), formatMoney(t.grossCents)];
}

/** Workshop ticket sales across the window, one row per region. Naming a region narrows
 *  the whole page to it. */
export function DailySalesRegions({ rows, region, onRegion }: DailySalesRegionsProps) {
  const totals = rows.map(combined);
  const sum = totals.reduce(addTotals, ZERO);
  const title = region ? `Tickets by region in ${region.name}` : 'Tickets by region';

  return (
    <section className="nb-card nb-ds-ledger" aria-label={title}>
      <table className="nb-tbl nb-tabular nb-ds-regions">
        <caption className="nb-display nb-ds-caption">{title}</caption>
        <thead>
          <tr>
            <th scope="col">Region</th>
            <th scope="col">Bookings</th>
            <th scope="col">Tickets</th>
            <th scope="col">Gross</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.regionId ?? 'none'}>
              <th scope="row">
                {row.regionId && row.regionId !== region?.id ? (
                  <button
                    type="button"
                    className="nb-ds-link"
                    onClick={() => onRegion(row.regionId as string)}
                  >
                    {row.name}
                  </button>
                ) : (
                  row.name
                )}
              </th>
              {cells(totals[i]).map((c, j) => (
                <td key={j}>{c}</td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="nb-ds-total">
            <th scope="row">Total</th>
            {cells(sum).map((c, j) => (
              <td key={j}>{c}</td>
            ))}
          </tr>
        </tfoot>
      </table>
    </section>
  );
}
